import { isPlatform } from "@ionic/react";

export const isCapacitor = isPlatform('capacitor');
export const isAndroid = isPlatform('android')
export const isIOS = isPlatform('ios');